import { Card, Col, Row, Space, Typography, Tabs, Divider, Tooltip, Radio, Flex } from "antd";
import React, { useState } from "react";
import ResultCard from "../../../../../components/ResultCard"
// import { LaserClassResults } from "../../../../../components/LaserClassResults";
// import { LaserClassResultsV2 } from "./LaserClassResultsV2";
// import LaserClassVerdict from "./LaserClassVerdict";
import eye from "../../../../../assets/Icons/eye black.png"
import hand from "../../../../../assets/Icons/hand black.png"
import beam from "../../../../../assets/Icons/beam black.png"
import { Eyewear } from "../../../../../components/TestAndLabelLinks";
import { EyewearResults } from "../../ResultComponents/EyewearResults";
import { AllAEL } from "../../../../../components/AELTab/AllAEL";
import { ANSILaserClassResults } from '../../../../../components/AELTab/ANSI/ANSILaserClassResults'
import LaserClassVerdict from "../../Results/MPE_AEL_Results/LaserClassVerdict";
import { AllAELANSI } from "../../../../../components/AELTab/ANSI/AllAELANSI";
import { Infograph } from "../../../../../components/infographicsModal/Infograph";
import useFreeMode from "../../Free/useFreeMode";
import { useTranslation } from "react-i18next";
import { AllAELDiffuse } from "../../../../../components/AELTab/AllAELDiffuse";
const { Text, Title } = Typography


export function DRResultCW({ result, units, laserOperation, data }) {
    const { isFree } = useFreeMode('diffuseReflective')
    const { MPE, AE } = result
    const textCenter = { display: 'flex', justifyContent: 'center' }
    const [isModalOpen, setIsModalOpen] = useState(false)
    const [info, setInfo] = useState(null)
    let props = { result: result, data: data, laserOperation: laserOperation }
    const { t } = useTranslation()
    const handleClick = (e) => {
        setIsModalOpen(true)
        setInfo(e)
    }
    const handleCancel = () => {
        setIsModalOpen(false)
    }
    // console.log(result)
    return (<Tabs items={[{
        key: 1,
        label: "MPE Details",
        children: (
            <>
                <Tabs centered items={[{
                    key: 1,
                    label: result?.albedo?.num + "% Albedo",
                    children:
                        <>
                            <Infograph
                                isModalOpen={isModalOpen}
                                setIsModalOpen={setIsModalOpen}
                                handleCancel={handleCancel}
                                info={info}
                            />
                            <Card style={{ marginBottom: "20px" }}>
                                <Divider><h4><img src={eye} width={50} style={{ marginRight: "5px" }} /><strong>{t('10104')/*Eye */}</strong></h4></Divider>
                                {/* Result for Custom Albedo */}
                                <Flex justify="center">
                                    <strong style={{ margin: '12px' }}>Result for {result?.albedo?.num}% Albedo</strong>
                                </Flex>
                                <Flex justify='center' style={{ margin: '10px 10px' }}>
                                    <Space size='middle'>
                                        <Flex >
                                            <Card>
                                                <Space direction="vertical">
                                                    <Flex justify="center"><strong>MPE</strong></Flex>
                                                    <Flex justify="center">
                                                        {/* {(() => {
                                                            if (units === "joules") {
                                                                return result?.MPE?.joulesPerSqmPretty?.eng + `J/m²`
                                                            }
                                                            else {
                                                                return result?.MPE?.wattsPerSqmPretty?.eng + `W/m²`
                                                            }
                                                        })()} */}
                                                        {result?.MPE?.mpeStandard?.pretty}
                                                    </Flex>
                                                </Space>
                                            </Card>
                                        </Flex>

                                        <Flex>
                                            <Card>
                                                <Space direction="vertical">
                                                    <Flex><strong> {t('10102') /*Accessible Emission*/}</strong></Flex>
                                                    <Flex justify="center">
                                                        {/* {(() => {
                                                            if (units === "joules") {
                                                                return result?.AE?.albedo_joulesPerSqmPretyy
                                                            }
                                                            else {
                                                                return result?.AE?.albedo_wattsPerSqmPretty
                                                            }
                                                        })()} */}
                                                        {props?.result?.MPE?.mpeStandard?.unit.includes("W") ? `${props?.result?.AE?.albedo_wattsPerSqmPretty}` : `${props?.result?.AE?.albedo_joulesPerSqmPretyy}`}

                                                    </Flex>
                                                </Space>
                                            </Card>
                                        </Flex>

                                        <Flex>
                                            <Card>
                                                <Space direction="vertical">
                                                    <Flex justify="center"><strong> {t('10103')/*Eye Safety Ratio*/}</strong></Flex>
                                                    <Flex justify="center"
                                                        style={(() => {
                                                            if (result?.MPEExcess?.albedo_wattsPerSqmPretty <= 0.5) {
                                                                return { color: 'green' }
                                                            }
                                                            else if (result?.MPEExcess?.albedo_wattsPerSqmPretty > 0.5 && result?.MPEExcess?.albedo_wattsPerSqmPretty <= 1) {
                                                                return { color: 'orange' }
                                                            } else {
                                                                return { color: 'red' }
                                                            }
                                                        })()}
                                                    ><strong>{result?.MPEExcess?.albedo_wattsPerSqmPretty}</strong></Flex>
                                                </Space>
                                            </Card>
                                        </Flex>
                                    </Space>
                                </Flex>
                                <Card style={{
                                    backgroundColor: (() => {
                                        if (result.MPEExcess?.albedo_wattsPerSqm > 1) {
                                            return "#d82424"
                                        }
                                        else if (result?.MPEExcess?.albedo_wattsPerSqm <= 0.5) {
                                            return "#10c96d"
                                        }
                                        else if (result?.MPEExcess?.albedo_wattsPerSqm > 0.5 || result?.MPEExcess?.albedo_wattsPerSqm <= 1) {
                                            return "#ffa200"
                                        }
                                    })()
                                }}

                                >
                                    <Flex justify="center">
                                        <strong style={{ color: "#ffffff" }}>
                                            {(() => {
                                                if (result?.MPEExcess?.wattsPerSqm > 1) {
                                                    return t('10108') // The configuration that has been entered is Dangerous for the Eye!
                                                }
                                                else if (result?.MPEExcess?.wattsPerSqm <= 0.5) {
                                                    return t('10109') // The configuration that has been entered is Safe for the Eye!
                                                }
                                                else if (result?.MPEExcess?.wattsPerSqm > 0.5 || result?.MPEExcess?.wattsPerSqm <= 1) {
                                                    return t('10110') // The configuration that has been entered is Marginally Safe for the Eye
                                                }
                                            })()}
                                        </strong>
                                    </Flex>
                                </Card>
                            </Card>
                            <Card style={{ marginBottom: "20px" }}>
                                <Divider><h4><img src={hand} width={50} style={{ marginRight: "5px" }} /><strong>  {t('10106') /*SKIN*/} </strong> </h4></Divider>
                                <Flex justify="center" gap={"middle"} style={{ margin: '10px 10px' }}>
                                    <Card>
                                        <Space direction="vertical">
                                            <Flex justify="center"><strong>MPE</strong></Flex>
                                            <Flex justify="center">
                                                {/* {(() => {
                                                    if (units === "joules") {
                                                        return result?.MPEskin?.joulesPerSqmPretty?.eng + `J/m²`
                                                    }
                                                    else {
                                                        return result?.MPEskin?.wattsPerSqmPretty?.eng + `W/m²`
                                                    }
                                                })()} */}
                                                {props?.result?.MPEskin?.mpeStandard?.pretty}
                                            </Flex>
                                        </Space>
                                    </Card>
                                    <Card>
                                        <Space direction="vertical">
                                            <Flex justify="center"><strong>Skin AE</strong></Flex>
                                            <Flex justify="center">
                                                {/* {(() => {
                                                    if (units === "joules") {
                                                        return result?.skinAE?.albedo_joulesPerSqmPretyy
                                                    }
                                                    else {
                                                        return result?.skinAE?.albedo_wattsPerSqmPretty
                                                    }
                                                })()} */}
                                                {props?.result?.MPEskin?.mpeStandard?.unit.includes("W") ? `${props?.result?.skinAE?.albedo_wattsPerSqmPretty}` : `${props?.result?.skinAE?.albedo_joulesPerSqmPretyy}`}
                                            </Flex>
                                        </Space>
                                    </Card>
                                    <Card>
                                        <Space direction="vertical">
                                            <Flex justify="center"><strong> {t('10107')/** Skin Safety Ratio*/}</strong></Flex>
                                            <Flex justify="center"
                                                style={(() => {
                                                    if (result?.skinMPEExcess?.albedo_wattsPerSqmPretty <= 0.5) {
                                                        return { color: 'green' }
                                                    }
                                                    else if (result?.skinMPEExcess?.albedo_wattsPerSqmPretty > 0.5 && result?.skinMPEExcess?.albedo_wattsPerSqmPretty <= 1) {
                                                        return { color: 'orange' }
                                                    } else {
                                                        return { color: 'red' }
                                                    }
                                                })()}
                                            ><strong>{result?.skinMPEExcess?.albedo_wattsPerSqmPretty}</strong></Flex>
                                        </Space>
                                    </Card>
                                </Flex>
                                <Card style={{
                                    backgroundColor: (() => {
                                        if (result?.skinMPEExcess?.albedo_wattsPerSqm > 1) {
                                            return "#d82424"
                                        }
                                        else if (result?.skinMPEExcess?.albedo_wattsPerSqm <= 0.5) {
                                            return "#10c96d"
                                        }
                                        else if (result?.skinMPEExcess?.albedo_wattsPerSqm > 0.5 || result?.skinMPEExcess?.albedo_wattsPerSqm <= 1) {
                                            return "#ffa200"
                                        }
                                    })()
                                }}>

                                    <Flex justify="center">
                                        <strong style={{ color: "#ffffff" }}>
                                            {(() => {
                                                if (result?.skinMPEExcess?.albedo_wattsPerSqm > 1) {
                                                    return t('101108') // The configuration that has been entered is Dangerous for the Skin!
                                                }
                                                else if (result?.skinMPEExcess?.albedo_wattsPerSqm <= 0.5) {
                                                    return t('101109') // The configuration that has been entered is Safe for the Skin! 
                                                }
                                                else if (result?.skinMPEExcess?.albedo_wattsPerSqm > 0.5 || result?.skinMPEExcess?.albedo_wattsPerSqm <= 1) {
                                                    return t('101110') // The configuration that has been entered is Marginally Safe for the Skin! 
                                                }
                                            })()}
                                        </strong>
                                    </Flex>
                                </Card>
                            </Card>
                        </>
                }, result?.albedo?.num === 100 ? null : {
                    key: 2,
                    label: "100% Albedo",
                    children:
                        <>
                            <Card style={{ marginBottom: "20px" }}>
                                <Divider><h4><img src={eye} width={50} style={{ marginRight: "5px" }} /><strong>{t('10104')/*Eye */}</strong></h4></Divider>
                                {/* Result for 100% Albedo */}
                                <Flex justify="center">
                                    <strong style={{ margin: '12px' }}>Result for 100% Albedo</strong>
                                </Flex>
                                <Flex justify='center' style={{ margin: '10px 10px' }}>
                                    <Space size='middle'>
                                        <Flex>
                                            <Card>
                                                <Space direction="vertical">
                                                    <Flex justify="center"><strong>MPE</strong></Flex>
                                                    <Flex justify="center">
                                                        {/* {(() => {
                                                            if (units === "joules") {
                                                                return result?.MPE?.joulesPerSqmPretty?.eng + `J/m²`
                                                            }
                                                            else {
                                                                return result?.MPE?.wattsPerSqmPretty?.eng + `W/m²`
                                                            }
                                                        })()} */}
                                                        {result?.MPE?.mpeStandard?.pretty}

                                                    </Flex>
                                                </Space>
                                            </Card>
                                        </Flex>

                                        <Flex>
                                            <Card>
                                                <Space direction="vertical">
                                                    <Flex><strong> {t('10102') /*Accessible Emission*/}</strong></Flex>
                                                    <Flex justify="center">
                                                        {/* {(() => {
                                                            if (units === "joules") {
                                                                return result?.AE?.joulesPerSqmPretty
                                                            }
                                                            else {
                                                                return result?.AE?.wattsPerSqmPretty
                                                            }
                                                        })()} */}
                                                        {props?.result?.MPE?.mpeStandard?.unit.includes("W") ? `${props?.result?.AE?.wattsPerSqmPretty}` : `${props?.result?.AE?.joulesPerSqmPretty}`}

                                                    </Flex>
                                                </Space>
                                            </Card>
                                        </Flex>

                                        <Flex>
                                            <Card >
                                                <Space direction="vertical">
                                                    <Flex justify="center"><strong> {t('10103')/*Eye Safety Ratio*/}</strong></Flex>
                                                    <Flex justify="center"
                                                        style={(() => {
                                                            if (result?.MPEExcess?.wattsPerSqmPretty <= 0.5) {
                                                                return { color: 'green' }
                                                            }
                                                            else if (result?.MPEExcess?.wattsPerSqmPretty > 0.5 && result?.MPEExcess?.wattsPerSqmPretty <= 1) {
                                                                return { color: 'orange' }
                                                            } else {
                                                                return { color: 'red' }
                                                            }
                                                        })()}
                                                    ><strong>{result?.MPEExcess?.wattsPerSqmPretty}</strong></Flex>
                                                </Space>
                                            </Card>
                                        </Flex>
                                    </Space>
                                </Flex>
                                <Card style={{
                                    backgroundColor: (() => {
                                        if (result?.MPEExcess?.wattsPerSqm > 1) {
                                            return "#d82424"
                                        }
                                        else if (result?.MPEExcess?.wattsPerSqm <= 0.5) {
                                            return "#10c96d"
                                        }
                                        else if (result?.MPEExcess?.wattsPerSqm > 0.5 || result?.MPEExcess?.wattsPerSqm <= 1) {
                                            return "#ffa200"
                                        }
                                    })()
                                }}

                                >
                                    <Flex justify="center">
                                        <strong style={{ color: "#ffffff" }}>
                                            {(() => {
                                                if (result?.MPEExcess?.wattsPerSqm > 1) {
                                                    return t('10108') // The configuration that has been entered is Dangerous for the Eye!
                                                }
                                                else if (result?.MPEExcess?.wattsPerSqm <= 0.5) {
                                                    return t('10109') // The configuration that has been entered is Safe for the Eye!
                                                }
                                                else if (result?.MPEExcess?.wattsPerSqm > 0.5 || result?.MPEExcess?.wattsPerSqm <= 1) {
                                                    return t('10110') // The configuration that has been entered is Marginally Safe for the Eye
                                                }
                                            })()}
                                        </strong>
                                    </Flex>
                                </Card>
                            </Card>
                            <Card style={{ marginBottom: "20px" }}>
                                <Divider><h4><img src={hand} width={50} style={{ marginRight: "5px" }} /><strong>  {t('10106') /*SKIN*/} </strong> </h4></Divider>
                                <Flex justify="center" gap={"middle"} style={{ margin: '10px 10px' }}>
                                    <Card>
                                        <Space direction="vertical">
                                            <Flex justify="center"><strong>MPE</strong></Flex>
                                            <Flex justify="center">
                                                {/* {(() => {
                                                    if (units === "joules") {
                                                        return result?.MPEskin?.joulesPerSqmPretty?.eng + `J/m²`
                                                    }
                                                    else {
                                                        return result?.MPEskin?.wattsPerSqmPretty?.eng + `W/m²`
                                                    }
                                                })()} */}
                                                {props?.result?.MPEskin?.mpeStandard?.pretty}
                                            </Flex>
                                        </Space>
                                    </Card>
                                    <Card>
                                        <Space direction="vertical">
                                            <Flex justify="center"><strong>Skin AE</strong></Flex>
                                            <Flex justify="center">
                                                {/* {(() => {
                                                    if (units === "joules") {
                                                        return result?.skinAE?.joulesPerSqmPretty
                                                    }
                                                    else {
                                                        return result?.skinAE?.wattsPerSqmPretty
                                                    }
                                                })()} */}
                                                {props?.result?.MPEskin?.mpeStandard?.unit.includes("W") ? `${props?.result?.skinAE?.wattsPerSqmPretty}` : `${props?.result?.skinAE?.joulesPerSqmPretty}`}

                                            </Flex>
                                        </Space>
                                    </Card>
                                    <Card>
                                        <Space direction="vertical">
                                            <Flex justify="center"><strong> {t('10107')/** Skin Safety Ratio*/}</strong></Flex>
                                            <Flex justify="center"
                                                style={(() => {
                                                    if (result?.skinMPEExcess?.wattsPerSqmPretty <= 0.5) {
                                                        return { color: 'green' }
                                                    }
                                                    else if (result?.skinMPEExcess?.wattsPerSqmPretty > 0.5 && result?.skinMPEExcess?.wattsPerSqmPretty <= 1) {
                                                        return { color: 'orange' }
                                                    } else {
                                                        return { color: 'red' }
                                                    }
                                                })()}
                                            ><strong>{result?.skinMPEExcess?.wattsPerSqmPretty}</strong></Flex>
                                        </Space>
                                    </Card>
                                </Flex>
                                <Card style={{
                                    backgroundColor: (() => {
                                        if (result?.skinMPEExcess?.wattsPerSqm > 1) {
                                            return "#d82424"
                                        }
                                        else if (result?.skinMPEExcess?.wattsPerSqm <= 0.5) {
                                            return "#10c96d"
                                        }
                                        else if (result?.skinMPEExcess?.wattsPerSqm > 0.5 || result?.skinMPEExcess?.wattsPerSqm <= 1) {
                                            return "#ffa200"
                                        }
                                    })()
                                }}>

                                    <Flex justify="center">
                                        <strong style={{ color: "#ffffff" }}>
                                            {(() => {

                                                if (result?.skinMPEExcess?.wattsPerSqm > 1) {
                                                    return t('101108') // The configuration that has been entered is Dangerous for the Skin!
                                                }
                                                else if (result?.skinMPEExcess?.wattsPerSqm <= 0.5) {
                                                    return t('101109') // The configuration that has been entered is Safe for the Skin! 
                                                }
                                                else if (result?.skinMPEExcess?.wattsPerSqm > 0.5 || result?.skinMPEExcess?.wattsPerSqm <= 1) {
                                                    return t('101110') // The configuration that has been entered is Marginally Safe for the Skin! 
                                                }
                                            })()}
                                        </strong>
                                    </Flex>
                                </Card>
                            </Card>
                        </>
                }]} />
                <Card>
                    <Divider><h4><img src={beam} width={50} /> <strong>{t('10111')/** BEAM PROPERTIES*/}</strong></h4></Divider>
                    <Flex justify={"center"} wrap="wrap"  >

                        <ResultCard>
                            <div onClick={() => { handleClick("NOHD") }} style={{ cursor: "pointer" }}>
                                <Flex justify="center"><strong>NOHD</strong></Flex>
                                <Flex justify="center">
                                    {(() => {
                                        if (result?.NOHD?.isError === true || result?.NOHD?.isError === undefined || result?.NOHD?.isError === null) {
                                            return <Tooltip title={result?.NOHD?.message}>N/A</Tooltip>
                                        } else {
                                            return result?.NOHD?.value?.pretty
                                        }
                                    })()}
                                </Flex>
                            </div>
                        </ResultCard>

                        <ResultCard>
                            <div onClick={() => { handleClick("ENOHD") }} style={{ cursor: "pointer" }}>
                                <Flex justify="center"><strong>ENOHD</strong></Flex>
                                {/* <Flex justify="center">{result?.ENOHD?.val !== null ? result.ENOHD.value.pretty : 'N/A'}</Flex> */}
                                <Flex justify="center">
                                    {(() => {
                                        if (result?.ENOHD?.isError === true || result?.ENOHD?.isError === undefined || result?.ENOHD?.isError === null) {
                                            return <Tooltip title='ENOHD is only applicable for wavelengths  between 302.5nm ~ 10⁶nm'>N/A</Tooltip>
                                        } else {
                                            return result?.ENOHD?.value?.pretty
                                        }
                                    })()}
                                </Flex>
                            </div>
                        </ResultCard>

                        <ResultCard>
                            <div onClick={() => { handleClick("Spot Size") }} style={{ cursor: "pointer" }}>
                                <Flex justify="center"><strong>  {t('10112') /** Spot Size */}</strong></Flex>
                                <Flex justify="center">{result?.outputBeamDiameter}</Flex>
                            </div>
                        </ResultCard>

                        <ResultCard>
                            <div onClick={() => { handleClick("limit aperture") }} style={{ cursor: "pointer" }}>
                                <Flex justify="center"><strong> {t('10113')/** Limit Aperture */}</strong></Flex>
                                <Flex justify="center">{result?.limitAperture?.eye + ' mm'}</Flex>
                                <Flex justify="center">{result?.limitAperture?.skin + ' mm'}</Flex>
                            </div>
                        </ResultCard>

                        <ResultCard>
                            <div onClick={() => { handleClick("applicable beam area") }} style={{ cursor: "pointer" }}>
                                <Space direction="vertical">
                                    <Flex justify="center"><strong>  {t('10114') /** Applicable Beam Area*/}</strong></Flex>
                                    <Flex justify="center">
                                        <Space direction="vertical">
                                            <Flex justify="center"><strong>Actual</strong></Flex>
                                            <Flex>{result?.beamArea?.actualPretty}</Flex>
                                        </Space>
                                        <Divider orientation="center" type="vertical" />
                                        <Space direction="vertical">
                                            <Flex><strong>Applicable</strong></Flex>
                                            <Flex>{result?.beamArea?.applicablePretty}</Flex>
                                        </Space>
                                    </Flex>
                                </Space>
                            </div>
                        </ResultCard>


                        <ResultCard style={{ width: "200px", height: "100px", display: "flex", justifyContent: "center", alignItems: "center" }}>
                            <div onClick={() => { handleClick("spectrum") }} style={{ cursor: "pointer" }}>
                                <strong> {t('10115')/** Spectrum*/}</strong>
                                <Row justify={"center"}>
                                    <div style={{
                                        width: "30px",
                                        height: "30px",
                                        backgroundColor: (() => {
                                            if (result?.spectrum?.range == "Infrared") {
                                                return "maroon"
                                            }
                                            else if (result?.spectrum?.range == "Ultraviolet") {
                                                return "purple"
                                            }
                                            return "rgb(" + result?.spectrum?.rgb + ")"
                                        })(),
                                        borderRadius: 100,
                                        ustifyContent: "center"
                                    }}>
                                    </div>
                                </Row>
                                <Row justify={"center"}>{result?.spectrum?.region}</Row>
                            </div>
                        </ResultCard>
                    </Flex>
                </Card>

            </>
        )
    }, {
        disabled: isFree,
        key: 2,
        label: t('10119') /*More Information*/,
        children:
            <>
                <Divider> {t('10124') /** Correction Factors & Time Bases*/}</Divider>
                <Flex justify="center">
                    <Space>
                        {result?.correctionFactors?.map((cf => {
                            return (
                                <Card>
                                    <Space direction="vertical">
                                        <Flex justify="center"><strong>{cf?.name}</strong></Flex>
                                        <Flex justify="center">{cf?.pretty}</Flex>
                                    </Space>
                                </Card>
                            )
                        }))}
                    </Space>
                </Flex>
                <Divider>Angular Parameters</Divider>
                <Flex justify="center">
                    <Space>
                        <Card>
                            <Space direction="vertical">
                                <Flex justify="center"><strong>Angular Subtense (diffused)</strong></Flex>
                                <Flex justify="center">{result?.angularSubtense}</Flex>
                            </Space>
                        </Card>

                        {/* <Card>
                            <Space direction="vertical">
                                <Flex justify="center"><strong>Angle of Acceptance</strong></Flex>
                                <Flex justify="center">{result.MPE.angleOfAcceptancePretty}</Flex>
                            </Space>
                        </Card> */}
                        {/*
                        <Card>
                            <Space direction="vertical">
                                <Flex justify="center"><strong>Alpha max</strong></Flex>
                                <Flex justify="center">1.3rad</Flex>
                            </Space>
                        </Card> */}
                    </Space>

                </Flex>

            </>
    }, {
        key: 3,
        label: "Laser Class Details",
        children:
            <>
                <Divider orientation="center">  {t('10130')/** Accessible Emission Limits*/} </Divider>
                {/* <LaserClassResultsV2 laserClass={result.laserClass} condition={1} />
                    <LaserClassResultsV2 laserClass={result.laserClass} condition={3} /> */}

                {/* <LaserClassResultsDiffuseReflective result={result} condition={1} laserOperation={laserOperation}/>
                <br />
                <LaserClassResultsDiffuseReflective result={result} condition={3} laserOperation={laserOperation}/> */}
                <AllAELDiffuse result={result} laserOperation={laserOperation} />
            </>
    }, {
        disabled: isFree,
        key: 4,
        label: t('10123') /*Laser Protective Eyewear*/,
        children: <>
            <EyewearResults props={props} />
            <Row justify={'center'}>
                <Eyewear />
            </Row></>
    }]} />);
}
